import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Container from '../../UI/Container';
import SmsReminderTable from './SmsReminderTable';

const useStyles = makeStyles({
    title: {
        marginBottom: '20px'
    },
});

const SmsReminderContainer = () => {
    const classes = useStyles();
    return (
        <Container>
            <Typography className={classes.title} variant="h6">
                SMS Reminder Lançamento
            </Typography>

            <SmsReminderTable />

        </Container>
    );
}

export default SmsReminderContainer;